import React from 'react'
import styled from 'styled-components'
import Button from '../Button/Button'

export interface UploadButtonProps {
  children: string
  disabled: boolean
  id: string
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const UploadButton = (props: UploadButtonProps) => {
  return (
    <React.Fragment>
      <HiddenInput
        disabled={props.disabled}
        id={props.id}
        onChange={props.onFileChange}
        type="file"
      />
      <LabelButton
        as="label"
        color={'#16a13b'}
        disabled={props.disabled}
        htmlFor={props.id}
      >
        {props.children}
      </LabelButton>
    </React.Fragment>
  )
}

const LabelButton = styled(Button)`
  input:focus + & {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }

  ${props =>
    props.disabled &&
    `background: #999;
    cursor: not-allowed;
    opacity: 0.65;`}
`

const HiddenInput = styled.input.attrs(() => ({
  type: 'file',
  accept: '.xls, .xlsx, .csv',
}))`
  opacity: 0;
  right: 0;
  top: 0;
  height: 0;
  width: 0;
`
